import { Routes, Route } from "react-router-dom";
import RoleManagementList from "../RoleManagementList";
import RolePermissionEditor from "../RolePermissionEditor";

/*
 * Role Permissions — entry router.
 * Landing page is Role Management (list of roles). Create/Edit/Duplicate all
 * land on the same RolePermissionEditor screen (see its `mode` prop) — Role
 * Details (name/description) and Permissions are configured together in one
 * place, never a separate dialog.
 */
const RolePermissions = () => (
  <Routes>
    <Route index element={<RoleManagementList />} />
    <Route path="new" element={<RolePermissionEditor mode="create" />} />
    <Route path=":roleId/duplicate" element={<RolePermissionEditor mode="duplicate" />} />
    <Route path=":roleId" element={<RolePermissionEditor mode="edit" />} />
  </Routes>
);

export default RolePermissions;
